import IEC61131 from "../../images/systemComponents/IEC61131.png";

import Layout from "../../components/Layout";
import { HighlightedCode } from "shared/components/HighlightedCode";



export const IEC61131Page = () => {
    const stCode = `VAR
CurrentTemp: REAL; // Текущая температура
Output: REAL; // Выходное значение
Error, Integral, Derivative, PreviousError: REAL;
Setpoint: REAL := 100.0;
Kp, Ki, Kd: REAL := 1.0, 0.1, 0.01;
END_VAR

Error := Setpoint - CurrentTemp;
Integral := Integral + Error;
Derivative := Error - PreviousError;
Output := Kp * Error + Ki * Integral + Kd * Derivative;
PreviousError := Error;`;

    return <Layout >
        <div className="container">
            <div className="article-container">
                <h1>
                    МЭК 61131 (Стандарт МЭК 61131-3: Языки программирования)
                </h1>
                <div className=" w-100 align-start d-flex flex-column">
                    <p >
                        Стандарт МЭК 61131 предназначен для обеспечения единого набора языков программирования для программируемых контроллеров и средств автоматизации производственных процессов, что позволяет упростить разработку и сопровождение программного обеспечения для автоматизации производственных процессов.
                    </p>
                    <p >
                        Основные цели и задачи стандарта МЭК 61131 включают:
                    </p>

                    <ul className="mb-4 description__list">
                        <li className="mb-1 description__number-li">Обеспечение единого синтаксиса и семантики для различных языков программирования, что упрощает обучение и понимание программного кода разработчиками.</li>
                        <li className="mb-1 description__number-li">Повышение переносимости программ между различными моделями и производителями программируемых контроллеров.</li>
                        <li className="mb-1 description__number-li">Обеспечение возможности структурирования программного кода для легкого понимания и сопровождения.</li>
                        <li className="mb-1 description__number-li">Поддержка различных типов задач автоматизации, включая управление процессами, обработку данных, коммуникацию и т.д.</li>
                        <li className="mb-1 description__number-li">Обеспечение возможности создания гибких и расширяемых систем управления.</li>
                    </ul>
                    <p >
                        В SCADA NPT Compact применяется МЭК 61131 ST (Structured Text). Для реализации различных задач в SCADA используются разные диалекты языка МЭК 61131 ST:
                    </p>

                    <ul >
                        <li className="mb-1 description__number-li">ST - классическая реализация для свободно программируемой логики.</li>
                        <li className="mb-1 description__number-li">ST Formula - для выражения в формулах при формировании отчетов.</li>
                        <li className="mb-1 description__number-li">ST Script - для периодических задач.</li>
                        <li className="mb-1 description__number-li">ST Query - для запросов в базу данных реального времени и к базе данных тегов.</li>
                    </ul>
                    <img
                        src={IEC61131}
                        className="mb-4 w-100 "
                        alt="Интерфейс для языка ST"
                    />

                    <p>ST позволяет описывать алгоритмы управления, которые включают в себя математические вычисления, обработку данных и реализацию сложных логических выражений.</p>



                    <p>
                        Пример использования ST в SCADA-системе:
                    </p>
                    <p>
                        Предположим, в SCADA-системе требуется реализовать алгоритм управления температурой в промышленной печи с использованием ПИД-регулятора. На языке ST этот алгоритм может выглядеть так:
                    </p>

                    <HighlightedCode
                        code={stCode}
                        language="iecst"
                        style={{ maxHeight: '400px' }}
                        className="custom-highlight"
                    />

                </div>

            </div>
        </div>
    </Layout>
}
export { IEC61131Page as Page }

// const Code = ({


// }) => {
//     const highlightedCode = hljs.highlight(
//         `VAR
// CurrentTemp: REAL; // Текущая температура. Входной сигнал, получаемый от устройства
// Output: REAL; // Выходное значение ПИД-регулятора. Выходной сигнал, передаваемый в устройство.
// //Локальные переменные:
// Error, Integral, Derivative, PreviousError: REAL;
// Setpoint: REAL := 100.0; // Уставка температуры
// Kp, Ki, Kd: REAL := 1.0, 0.1, 0.01; // Коэффициенты ПИД-регулятора
// END_VAR

// // Расчёт ошибки
// Error := Setpoint - CurrentTemp;

// // Расчёт интегральной составляющей
// Integral := Integral + Error;

// // Расчёт дифференциальной составляющей
// Derivative := Error - PreviousError;

// // Расчёт выходного значения
// Output := Kp * Error + Ki * Integral + Kd * Derivative;

// // Обновление предыдущей ошибки
// PreviousError := Error;
//         `
//         , {
//             language: "iecst",
//         }).value;

//     return (
//         <pre style={{
//             padding: '1rem',
//             color: '#a9b7c6',
//             background: '#16171a',
//             borderRadius: '10px'
//         }}>
//             <code>
//                 <div dangerouslySetInnerHTML={{ __html: highlightedCode }}></div>
//             </code>
//         </pre>
//     );
// };